import { render, staticRenderFns } from "./Symptom.vue?vue&type=template&id=45a03ec4"
import script from "./Symptom.vue?vue&type=script&lang=js"
export * from "./Symptom.vue?vue&type=script&lang=js"
import style0 from "./Symptom.vue?vue&type=style&index=0&id=45a03ec4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports